module.exports = "/images/back-arrow.svg?5540fc24d6eb8992a7cd6d80d063ae96";